
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';

interface Treatment {
  date: string;
  treatment: string;
  notes: string;
  amount: string;
}

interface TreatmentHistoryCardProps {
  treatments: Treatment[];
  isLoading?: boolean;
}

const TreatmentHistoryCard: React.FC<TreatmentHistoryCardProps> = ({ 
  treatments = [],
  isLoading = false 
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Treatment History</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="h-8 w-8 animate-spin text-primary mr-2" />
            <span>Loading treatments...</span>
          </div>
        ) : treatments.length > 0 ? (
          <div className="space-y-4">
            {treatments.map((treatment, index) => (
              <div key={index} className="border-b pb-3 last:border-0 last:pb-0">
                <div className="flex justify-between mb-1">
                  <div className="font-semibold">{treatment.treatment}</div>
                  <div className="text-right font-medium text-green-600">{treatment.amount}</div>
                </div>
                <div className="flex justify-between text-sm">
                  <div className="text-muted-foreground">{treatment.date}</div>
                </div>
                {treatment.notes && (
                  <div className="mt-2 text-sm text-muted-foreground">
                    {treatment.notes}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="py-8 text-center text-muted-foreground">
            No treatments found for this patient.
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TreatmentHistoryCard;
